import React, { useEffect } from 'react';
import Validator from 'validatorjs';
import { Row, Col, Form } from 'react-bootstrap';

import useGlobal from '../../../../store';
import { Auth } from '../../../../support';
import { FormControl } from '../../../../facturotopia';
import Loading from '../../../../facturotopia/loading/Loading';

const rules = {
  role: ['required'],
};

const UsuarioRolesForm = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const validate = (role) => {
    const validator = new Validator(role, rules);

    return validator.passes();
  };

  useEffect(() => {
    actions.getRoles({ include: 'permissions' });
  }, []); // eslint-disable-line

  const optionsRoles = (roles) => {
    const auth = Auth.getData();
    const { user } = auth;
    const { roles: rol } = user;

    const tag = rol[0].role;

    const options = roles
      .filter((role) => {
        if (tag === 'root' || tag === 'admin') {
          return role;
        } else {
          return role.role !== 'root' && role.role !== 'admin';
        }
      })
      .map((role) => {
        return {
          label: role.description,
          value: role.id,
        };
      });

    return [
      {
        label: 'Selecciona un rol',
        value: '',
      },
    ].concat(options);
  };

  if (state.busy) {
    return <Loading />;
  }

  const { data } = state;

  const handleOnChange = (value, param) => {
    const role = data.find((item) => value.role === item.id);

    if (role?.permissions) {
      const permissions = {};

      for (const item of role.permissions) {
        permissions[item.id] = true;
      }

      props.onChange({
        ...value,
        selected: permissions,
        isPermissionsValid: validate(role),
      });
    } else {
      const { permissions } = props;

      const currentPermissions = {};

      if (permissions) {
        for (const item of permissions) {
          currentPermissions[item.id] = true;
        }
      }

      props.onChange({
        ...value,
        isPermissionsValid: validate(role),
        selected: currentPermissions,
      });
    }
  };

  const roles = optionsRoles(data);

  return (
    <>
      <Row className="mb-3">
        <Col
          xs
          sm={8}
          md={5}
        >
          <Form autoComplete="off">
            <FormControl
              type="select"
              name="role"
              rules={rules.role}
              value={props.role}
              options={roles}
              onChange={handleOnChange}
              disabled={props.propietario}
            />
          </Form>
        </Col>
      </Row>
    </>
  );
};

const mapState = (state) => {
  return {
    data: state.app.usuarios.roles.data,
  };
};

const mapActions = (actions) => {
  return {
    getRoles: actions.app.usuarios.roles.roles,
  };
};

export default UsuarioRolesForm;
